module.exports = __webpack_public_path__ + "static/img/kols6.56d42ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/kols/kols6.png
// module id = 5EEh
// module chunks = 0